(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/themes/sport-table-tennis/assets/javascripts/init-box.js') >= 0) return;  svs.modules.push('/components/themes/sport-table-tennis/assets/javascripts/init-box.js'); "use strict";

(function () {
  svs = svs || {};
  svs.themes = svs.themes || {};
  svs.themes.sport_table_tennis = svs.themes.sport_table_tennis || {}; 

  svs.themes.sport_table_tennis.initStatus = function (data) {
    setTimeout(function () {
      var $init = $("[data-init-id=\"".concat(data.matchId, "\"] .js-live-clock"));

      if ($init.length) {
        _.each($init, function (init) {
          $(init).replaceWith(svs.themes.sport_table_tennis.initStatusStart(data));
        });
      }
    }, 60000); 

    var $init = $("[data-init-id=\"".concat(data.matchId, "\"] .js-live-clock"));

    if ($init.length) {
      _.each($init, function (init) {
        $(init).replaceWith(svs.themes.sport_table_tennis.initStatusStart(data, true));
      });
    }
  };


  svs.themes.sport_table_tennis.hasMatchMinutes = function () {
    return true;
  };


  svs.themes.sport_table_tennis.initStatusStart = function (data, noclock) {
    var diff = 0;

    if (svs.themes.sport_table_tennis.isLive(data.status.id)) {
      if (data.status.id >= 8 && data.status.id <= 12) {
        return "<div class=\"brick match-status brick-active f-condensed align-center\">SET ".concat(data.status.id - 7, "</div>");
      }

      if (data.status.id === 63 || data.status.id === 64) {
        return "<div class=\"brick match-status brick-active f-condensed align-center\">SET ".concat(data.status.id - 57, "</div>");
      }

      if (data.status.id === 13) {
        return '<div class="brick match-status brick-active f-condensed align-center">STARTAT</div>';
      } 


      if (data.status.id === 14) {
        return '<div class="brick match-status brick-active f-condensed align-center">PAUS</div>';
      } 


      if (data.status.id === 26) {
        return '<div class="brick match-status brick-active f-condensed align-center">AVBR</div>';
      } 


      if (data.status.id === 27) {
        return '<div class="brick match-status brick-active f-condensed align-center">UPPH</div>';
      }

      if (data.status.realTime) {
        diff = Math.ceil(Math.abs(svs.themes.getDifferenceBetweenDates(data.status.realTime, new Date().setSeconds(0, 0), 'minutes', false)));
      }

      if (diff >= 0) {
        data.status.minutes = diff;
      } else {
        data.status.minutes = 1;
      } 


      if (!noclock) {
        svs.themes.sport_table_tennis.initStatus(data);
      }

      return "<div data-init-time-status=\"".concat(data.timeId, "\" class=\"brick js-live-clock match-status brick-active f-condensed align-center\">").concat(data.status.minutes, "'</div>");
    } else if (svs.themes.sport_table_tennis.isEnded(data.status.id)) {
      if (data.status.id === 25) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">INST</div>';
      } 


      if (data.status.id === 28) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">UPPH</div>';
      } 


      if (data.status.id === 29 || data.status.id === 116 || data.status.id === 117 || data.status.id === 120 || data.status.id === 121) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
      } 


      if (data.status.id === 26 || data.status.id === 30 || data.status.id === 118 || data.status.id === 119) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">AVBR</div>';
      } 


      if (data.status.id === 31 || data.status.id === 41) {
        return '<div class="brick match-status brick-border brick-inactive f-condensed align-center">SLUT</div>';
      }
    } else if (data.startTime) {
      return "<div class=\"brick match-status brick-border f-condensed align-center\">".concat(svs.themes.formatTime(data.startTime), "</div>");
    }

    return '';
  };
})();
 })(window);